import { bffURL, envAlias, sourceTrackingAppId } from '../config/endpoints'
import { newId, track } from './sourceTracking'

const APP_TITLE = 'social-recruiting-applicant-ui'
const APP_PACKAGE_NAME = 'AmplifyService'
export const CHANNEL_TR_APPLY = 'TalentReef Apply'
const CLIENT_ID = 'social-recruiting-applicant-ui'

let producer = null

/**
 * Browser producer for the applicant-bff Source Tracking collector. The service name and the
 * `appId`/`packageName` identity are kept from the retired Pinpoint SDK so `raw_events/` history
 * stays queryable by the same keys.
 */
export default class AmplifyService {
  static initialize = () => {
    producer = {
      environment: envAlias,
      appId: sourceTrackingAppId,
      title: APP_TITLE,
      packageName: APP_PACKAGE_NAME,
      clientId: CLIENT_ID,
      sessionId: newId(),
    }
  }

  static sendEvent = (event) => {
    if (!producer) {
      return
    }
    try {
      track(producer, bffURL, event)
    } catch (e) {
      console.error('Error sending source tracking event', e)
    }
  }

  static sendViewedEvent = async (eventAttributes) => {
    const applicationChannel = CHANNEL_TR_APPLY
    AmplifyService.sendEvent({
      name: 'Application Viewed',
      attributes: {
        applicationChannel,
        ...eventAttributes,
      },
    })
  }

  static extractSourceFromReferrer = (referrerUrl) => {
    try {
      const hostname = new URL(referrerUrl).hostname
      return hostname
    } catch (e) {
      return undefined
    }
  }

  static extractUtmSource = (currentUrl) => {
    const match = currentUrl.match(/[?&]utm_source=([^?&]+)/)
    return match ? match[1] : undefined
  }
}
